



















































import { Vue, Component } from 'vue-property-decorator';
import HeaderSection from './HeaderSection.vue';
import Card from './Card.vue';
import btn from './btn.vue';
import PackageCard from './PackageCard.vue';
import Axios from 'axios';
import alzuhudLink from "@/components/Functions/Functions";
import {State} from "vuex-class";

@Component({
    components: {
        HeaderSection,
        Card,
        btn,
        PackageCard
    }
})
export default class PackagesSection extends Vue {
    private selectedIndex: number;
    window: number = 0;
    block: boolean = true;
    packages: any[] = [];
    @State language: any;

    resizeBtn():void {
        let width = document.body.clientWidth;
        if (width < 940) {
            this.block = true;
        } else {
            this.block = false;
        }
    }
    /**
     *
     */
    constructor() {
        super();
        this.selectedIndex = 0;
    }

    async mounted() {
        document.title = 'Packages - Alzuhud';
        const response = await Axios.get(`http://${alzuhudLink}:8080/api/packages/all`, {

        });

        this.packages = response.data.res.data.map((item: any) => ({
            name: item.name,
            rating: item.rate,
            date: item.start_date,
            packageCode: item.code,
            price: item.price,
            start_date: item.start_date
        }))


    }
}
